import { getSkillsListQueryOptions, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import { gigTemplatesQuery } from "domains/postGig/containers/PositionSelect/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: Pick<ForManagerLocationDetail, "id"> };

export const skillsQuery = () =>
  getSkillsListQueryOptions(
    { include_defaults: true, include_recommendations: true, query: "ordered_by_popularity" },
    { query: { staleTime: Number.POSITIVE_INFINITY } },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [skillsQuery(), gigTemplatesQuery(input)];
